import type { ExtractInjectionAPI } from "@atlaskit/editor-common/types";
import type { EditorView } from "@atlaskit/editor-prosemirror/view";

import type { AIPlugin } from "../../../aiPluginType";
import type { PurePmInEditorDirectStreamingPluginState } from "../types";

/**
 * Expands all expand/nestedExpand nodes in the streamed content range.
 * Called when aiContentEndPos changes to ensure newly streamed expand nodes are opened.
 */
export function handleExpandNodes(
	view: EditorView,
	state: PurePmInEditorDirectStreamingPluginState,
	prevState: PurePmInEditorDirectStreamingPluginState | undefined,
	api: ExtractInjectionAPI<AIPlugin>,
) {
	if (
		!state.aiContentEndPos ||
		state.aiContentEndPos === prevState?.aiContentEndPos ||
		state.startPos === undefined
	) {
		return;
	}

	const { expand, nestedExpand } = view.state.schema.nodes;
	if (!expand && !nestedExpand) {
		return;
	}

	const startPos = state.startPos;
	const endPos = Math.min(state.aiContentEndPos, view.state.doc.content.size);
	if (startPos >= endPos) {
		return;
	}

	api?.expand?.commands.toggleExpandRange(startPos, endPos);
}
